// EditHazardPanel/index.js
import { connect } from 'react-redux';
import EditHazardPanel from '../../components/EditHazardPanel';
import { domainType } from '../../constants';

import {
  openEditHazardPanelDispatch,
  handleHazardInputChangeDispatch,
  submitHazardDispatch,
  fetchControlsForTheHazardDispatch,
  submitControlDispatch,
  enableEditHazardControlDispatch,
  handleEditHazardControlInputChangeDispatch,
  openAddHazardControlDialogDispatch,
  openDeleteHazardControlDialogDispatch,
  removeHazardControlAttachmentEdit,
  fetchExistingAttachmentsForHazardControlDispatch,
  openDocumentListDialogDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openPanel: state.hazard.newHazard.showEditHazardPanel,
    hazard: state.hazard.newHazard.item,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    controls: state.hazard.controlsForTheHazard.items,
    control: state.hazard.newControl.item,
    isEditControlEnabled: state.hazard.editControl.enable,
    controlBeingEdited: state.hazard.editControl.item,
    openAddHazardControlDialog:
      state.hazard.newControl.openAddHazardControlDialog,
    showDeleteHazardControlDialog:
      state.hazard.deleteControl.showDeleteHazardControlDialog,
    userId: state.users.user.item,
    allAttachments:
      state.hazard.editControl.item &&
      state.hazard.editControl.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openEditHazardPanel: (open) => {
      dispatch(openEditHazardPanelDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleHazardInputChangeDispatch(value, inputFieldName));
    },
    submitHazard: (accident) => {
      const mode = submitMode.UPDATE;
      dispatch(submitHazardDispatch(accident, mode));
    },
    fetchControlsForTheHazard: (hazardId) => {
      dispatch(fetchControlsForTheHazardDispatch(hazardId));
    },
    submitControl: (payload, mode, branchId) => {
      dispatch(submitControlDispatch(payload, mode, branchId));
    },
    enableEditHazardControl: (enableEditControlMode, parentId, userId) => {
      dispatch(
        enableEditHazardControlDispatch(enableEditControlMode, parentId)
      );
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardControlAttachmentEdit(attachment));
    },
    onHandleEditHazardControlInputChange: (value, inputFieldName) => {
      dispatch(
        handleEditHazardControlInputChangeDispatch(value, inputFieldName)
      );
    },
    onOpenAddHazardControlDialog: (open) => {
      dispatch(openAddHazardControlDialogDispatch(open));
    },
    onOpenDeleteControlDialog: (open, controlId) => {
      dispatch(openDeleteHazardControlDialogDispatch(open, controlId));
    },
    openDocumentListDialog: (open) => {
      dispatch(openDocumentListDialogDispatch(open));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditHazardPanel);
